import { Gender } from "constants/enums";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { FormField, RadioButton } from "ui";

import { NotificationFormValues } from "../NotificationForm.types";

import styles from "../NotificationForm.module.scss";

export const GenderField = () => {
  const { t } = useTranslation();
  const { control } = useFormContext<NotificationFormValues>();

  return (
    <Controller
      control={control}
      name={"targetGender"}
      render={({
        field: { value, onChange },
        fieldState: { error: _error }
      }) => (
        <FormField label={t("Gender")} labelClassName={styles.form_fieldLabel}>
          <div className={styles.form_genderBtns}>
            <RadioButton
              checked={value === Gender.All}
              value={Gender.All}
              onChange={onChange}
              label={t("All")}
            />
            <RadioButton
              checked={value === Gender.Male}
              value={Gender.Male}
              onChange={onChange}
              label={t("Male")}
            />
            <RadioButton
              checked={value === Gender.Female}
              value={Gender.Female}
              onChange={onChange}
              label={t("Female")}
            />
          </div>
        </FormField>
      )}
    />
  );
};
